import { mergeClasses } from '@/utils/style';
import React, { PropsWithChildren } from 'react';

interface Props {
	className?: string;
	id?: string;
	ref?: React.RefObject<HTMLDivElement | null>;
}

export function ContentContainer(props: PropsWithChildren<Props>): React.JSX.Element {
	const { id, children, className, ref } = props;

	return (
		<div
			className={mergeClasses(
				'relative m-auto w-full max-w-292',
				id && 'scroll-mt-20 lg:scroll-mt-32',
				className
			)}
			id={id}
			ref={ref}
		>
			{children}
		</div>
	);
}
